import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Comment")
], -1)
const _hoisted_2 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_ctx.props.scope.row?.comment?.length > 0)
    ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        placement: "top",
        width: "auto",
        trigger: "hover"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_tag, {
            type: _ctx.getOrderStatusColor(_ctx.props.scope.row.status),
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.statusTitleMap.get(_ctx.props.scope.row.status)), 1)
            ]),
            _: 1
          }, 8, ["type"])
        ]),
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.props.scope.row.comment), 1)
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_el_tag, {
        key: 1,
        type: _ctx.getOrderStatusColor(_ctx.props.scope.row.status),
        title: _ctx.statusTitleMap.get(_ctx.props.scope.row.status),
        size: "small"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.statusTitleMap.get(_ctx.props.scope.row.status)), 1)
        ]),
        _: 1
      }, 8, ["type", "title"]))
}